import React from 'react'
import SubmissionsSection from '../submissions/SubmissionsSection'
import { useParams } from 'react-router'
import DashboardSection from '../reports/dashboard-section/DashboardSection'

const TextHomeSection = () => {
    const { layerId } = useParams()

    return layerId === 'dashboard' ? <DashboardSection /> : <SubmissionsSection />
}

export default TextHomeSection
